/* eslint-disable complexity */

import React from 'react';

import ImageSize from './Sizes/ImageSize';
import FilmSize from './Sizes/FilmSize.tsx';

import styles from './AssetSizes.module.scss';
import useSelectedIndex from '../../../hooks/stateful/useSelectedIndex.ts';
import { useAsset } from '../../../hooks/stateful/useAsset';
import useOnLoad from '../../../hooks/queries/useOnLoad';

const SingleAssetSize = () => {
  const { asset } = useAsset();
  const { response: { config: { options } = {} } = {} } = useOnLoad();
  const {
    selectedOptionIndex = 0,
    selectedSize,
    selectedSizeIndex,
  } = useSelectedIndex();
  const selectedOption =
    options?.length > 0 ? options[selectedOptionIndex] : null;

  const getSizeDisplay = (size, index) => {
    if (asset.isFilm()) {
      return (
        <FilmSize
          key={size.name}
          size={size}
          index={index}
          singleView
        />
      );
    }
    return (
      <ImageSize
        key={size.name}
        size={size}
        index={index}
        singleView
      />
    );
  };

  if (!selectedOption?.sizes) return null;

  return (
    <div
      className={styles.table}
      data-testid="selected-asset-size"
      key="assetSize"
    >
      {getSizeDisplay(selectedSize, selectedSizeIndex)}
    </div>
  );
};

export default SingleAssetSize;
